module.exports = __webpack_public_path__ + "media/AdminSSO.d6c1e7d40ca541389aae1cc862c52ef3.svg";